import { OperatorPresence } from '@/types';

export const HERE_MAP_KEY = process.env.VITE_APP_HERE_MAP_API_KEY ?? '';
export const DEFAULT_MAP_CENTER = {
  lat: 53.6203093,
  lng: -0.9709763,
};
export const DEFAULT_MAP_ZOOM = 16;

export const VESSEL_MAP_ZOOM = 5;

export const VESSEL_MARKER_ICON = '/images/vessel-marker.svg';

export const GRIMSBY_MAP_CENTER = {
  lat: 53.56539,
  lng: -0.07553,
};

export const PRESENCE_COLORS: Record<OperatorPresence, string> = {
  Online: '#4CAF50',
  Away: '#FFC107',
  Offline: '#424242',
};
